import { render, staticRenderFns } from "./ColorBtns.vue?vue&type=template&id=ea2a167a&"
import script from "./ColorBtns.vue?vue&type=script&lang=js&"
export * from "./ColorBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports